export const headlinks: HeadLinksI = [
	{ text: "Home", to: "home", scrollOn: "/" },
	{ text: "About Us", to: "about", scrollOn: "/" },
	{ text: "Our Services", to: "services", scrollOn: "/" },
	{ text: "Our Process", to: "process", scrollOn: "/", },
	{ text: "Testimonials", to: "testimonials", scrollOn: "/" },
	{ text: "Our Story", to: "/story" },
	{ text: "Blog", to: "/blog" },
	{ text: "Store", to: "/store" },
	{ text: "FAQs", to: "faqs", scrollOn: "/" },
]

export const blogNavLinks: HeadLinksI = [
	{ text: "Home", to: "home", scrollOn: "/blog" },
	{ text: "About Us", to: "about", scrollOn: "/" },
	{ text: "Services", to: "services", scrollOn: "/" },
	{ text: "All Posts", to: "/blog/all" },
	{ text: "Store", to: "/store" },
]

export type HeadLinksI = {
	text: string, // link text
	to: string, // link, can also be id of target element
	scrollOn?: string // route to scroll on if using id in `to`
}[]